import React from 'react';
// @ts-ignore
import { Button, Heading, Table, Link, Loader } from 'arag-ui-lib';
import moment from 'moment';
import config from '../../utils/constants/config';
import styles from '../../assets/styles/generalStyle.module.scss';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n/i18n';

type ClaimListTable =
    | {
          claimReference: string;
          formattedType: string;
          createdDate: moment.MomentInput;
          claimStatusName: string;
      }
    | any;
type Props = {
    claimApplicationsList: Array<ClaimListTable>;
    onClickResumeClaim: (arg0: string) => void;
    onClickViewDetails: (arg0: string) => void;
    onCreateNewClaim: () => void;
    onPageSizeChange: (evt: React.ChangeEvent<HTMLInputElement>) => void;
    pager: {
        limit: number;
        totalItems: number | null;
        totalPages: number | null;
        page: number;
    };
    goAtPage: () => void;
    goAtStart: () => void;
    goAtEnd: () => void;
    goAtNext: () => void;
    goAtPrevious: () => void;
    loading: boolean;
};
const columns = (
    onClickResumeClaim: (arg0: string) => void,
    onClickViewDetails: (arg0: string) => void,
) => [
    {
        propertyName: 'claimReference',
        header: i18n.t('claimReference'),
        id: 'claimReference',
        sortable: false,
    },
    {
        propertyName: 'formattedType',
        header: i18n.t('formType'),
        id: 'formattedType',
        sortable: false,
    },
    {
        propertyName: 'createdDate',
        header: i18n.t('date'),
        id: 'createdDate',
        sortable: false,
        formatter: (row: { createdDate: moment.MomentInput }) =>
            `${moment(row.createdDate).format('DD/MM/YYYY')}`,
    },
    {
        propertyName: 'claimStatusName',
        header: i18n.t('stage'),
        id: 'Stage',
        sortable: false,
    },
    {
        propertyName: '',
        header: i18n.t('actions'),
        id: '',
        sortable: false,
        formatter: (row: { id: string; isDraft: boolean }) => (
            <div>
                <div>
                    <Link
                        variant={'tertiary'}
                        arrowDirection={'left'}
                        label={i18n.t('viewDetails')}
                        onClick={() => onClickViewDetails(`/claims/${row.id}`)}
                    />
                </div>
                {row.isDraft && (
                    <div>
                        <Link
                            variant={'tertiary'}
                            arrowDirection={'left'}
                            label={i18n.t('resumeClaim')}
                            onClick={() => onClickResumeClaim(row.id)}
                        />
                    </div>
                )}
            </div>
        ),
    },
];

const ClaimsList = (props: Props): JSX.Element => {
    const {
        claimApplicationsList,
        onClickResumeClaim,
        onClickViewDetails,
        onCreateNewClaim,
        pager,
        onPageSizeChange,
        goAtPage,
        goAtStart,
        goAtEnd,
        goAtNext,
        goAtPrevious,
        loading,
    } = props;
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <Heading variant="h2" title={t('claimsCapitalFirstLetter')} />
            <div className={styles['content-marginTop-marginBottom']}>
                <Button
                    variant={'primary'}
                    label={t('newClaim')}
                    arrowDirection={'right'}
                    onClick={onCreateNewClaim}
                />
            </div>
            <p />
            {loading ? (
                <Loader variant={'inline'} label={t('loading')} />
            ) : (
                <div>
                    {pager && pager.totalItems ? (
                        <Table
                            loading={loading}
                            striped
                            columns={columns(
                                onClickResumeClaim,
                                onClickViewDetails,
                            )}
                            data={claimApplicationsList}
                            accordionItemHeaderFormatter={(row: {
                                claimReference: string;
                                claimStatusName: string;
                            }) => (
                                <div>{`${row.claimReference} ${row.claimStatusName}`}</div>
                            )}
                            pageSize={pager.limit || 0}
                            totalRecords={pager.totalItems || 0}
                            totalPages={pager.totalPages || 0}
                            page={pager.page}
                            pageSizeOptions={config.listSizeOptions}
                            goAtPrevious={goAtPrevious}
                            goAtNext={goAtNext}
                            goAtStart={goAtStart}
                            goAtEnd={goAtEnd}
                            goAtPage={goAtPage}
                            onPageSizeChange={onPageSizeChange}
                            noResultsMessage={
                                'No results matching filter criteria found'
                            }
                        />
                    ) : null}
                </div>
            )}
        </React.Fragment>
    );
};

export default ClaimsList;
